import Rails from '@rails/ujs'
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  setCodeValue (e) {
    Rails.fire(e.target.parentElement, 'submit')
  }
}
